module.exports = __webpack_public_path__ + "static/media/patient.3db299f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Directions/patient.png
// module id = 662
// module chunks = 0